import { isEmpty } from 'lodash';

const isRichTextEmpty = (html) => !html || (html.replace(/<[^>]*>/g, '').trim() === '' && !/<img[\s>]/i.test(html));

const checkFormUpsertValidation = ({ formField, errorFields }) => {
  const allSectionsFilled =
    !isEmpty(formField?.sections) && formField.sections.every((section) => !isEmpty(section?.title) && !isRichTextEmpty(section?.description));

  const isSpecialEventFieldValid = formField?.isSpecialEvent ? !isEmpty(formField?.host) && formField?.startTime !== null && formField?.endTime !== null : true;

  const isValidSubmit =
    !isEmpty(formField?.brand) &&
    !isEmpty(formField?.displayDateRange) &&
    !isEmpty(formField?.title) &&
    !isEmpty(formField?.productHighlight) &&
    allSectionsFilled &&
    isSpecialEventFieldValid &&
    isEmpty(errorFields);

  const isValidDraft = !isEmpty(formField?.brand) && !isEmpty(formField?.displayDateRange) && isSpecialEventFieldValid && !isEmpty(formField?.title);

  return { isValidSubmit, isValidDraft };
};

export default checkFormUpsertValidation;
